import React from 'react';
import { ReactComponent as BestFriends } from 'src/assets/images/appicons/appicon-best-friends.svg';
import { ReactComponent as Catalog } from 'src/assets/images/appicons/appicon-catalog.svg';
import { ReactComponent as Chat } from 'src/assets/images/appicons/appicon-chat-keyboard.svg';
import { ReactComponent as Fortune } from 'src/assets/images/appicons/appicon-fortune.svg';
import { ReactComponent as LifeSupports } from 'src/assets/images/appicons/appicon-life-supports.svg';
import { ReactComponent as MyDesign } from 'src/assets/images/appicons/appicon-mydesign.svg';
import { ReactComponent as Newspaper } from 'src/assets/images/appicons/appicon-newspaper.svg';
import { ReactComponent as Passport } from 'src/assets/images/appicons/appicon-passport.svg';
import { ReactComponent as Reaction } from 'src/assets/images/appicons/appicon-reaction.svg';
import { ReactComponent as Resort } from 'src/assets/images/appicons/appicon-resort.svg';
import { ReactComponent as Settings } from 'src/assets/images/appicons/appicon-settings.svg';
import { FeatureType } from './AppIcon';

interface AppIconImageProps {
  feature: FeatureType;
  width: string;
  height: string;
}

export const AppIconImage: React.FC<AppIconImageProps> = ({ feature, width, height }) => {
  switch (feature) {
    case 'passport':
      return <Passport width={width} height={height} />;
    case 'my-design':
      return <MyDesign width={width} height={height} />;
    case 'chat':
      return <Chat width={width} height={height} />;
    case 'best-friends':
      return <BestFriends width={width} height={height} />;
    case 'reaction':
      return <Reaction width={width} height={height} />;
    case 'catalog':
      return <Catalog width={width} height={height} />;
    case 'fortune':
      return <Fortune width={width} height={height} />;
    case 'resort':
      return <Resort width={width} height={height} />;
    case 'life-supports':
      return <LifeSupports width={width} height={height} />;
    case 'newspaper':
      return <Newspaper width={width} height={height} />;
    case 'settings':
      return <Settings width={width} height={height} />;
    default:
      return null;
  }
};
